export default "__VITE_ASSET__DYegA8BT__"